/* ==========================================================
FREE ITEMS ENTFERNEN sobald Threshold unterschritten wurde
========================================================== */

(function() {

  function getFreeItemConfigs() {
    const itemEls = document.querySelectorAll('.free-item-values');
    if (!itemEls.length) return [];

    return Array.from(itemEls).map((el) => ({
      variantId: parseInt(el.dataset.variantId, 10),
      threshold: parseInt(el.dataset.freeItemThreshold, 10),
      title: el.dataset.productTitle || 'Free Item'
    }));
  }

  async function fetchCurrentCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Cart fetch failed');
      return await response.json();
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async function removeLineItem(lineItemKey) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0
        })
      });

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      
      if (window.Shopify && window.Shopify.onCartUpdate) {
        window.Shopify.onCartUpdate(); 
      }
      
    } catch (e) {
      console.error(e);
    }
  }

  async function cleanUpFreeItems() {
    const freeItems = getFreeItemConfigs();
    if (!freeItems.length) return;

    const cart = await fetchCurrentCart();
    if (!cart || !cart.items) return;

    for (const config of freeItems) {
      const itemInCart = cart.items.find(item => item.variant_id === config.variantId);

      if (!itemInCart) continue;

      const currentCartTotal = cart.total_price;
      const itemLinePrice = itemInCart.final_line_price || 0; 
      const subtotalWithoutThisItem = currentCartTotal - itemLinePrice;

      if (subtotalWithoutThisItem < config.threshold) {
        await removeLineItem(itemInCart.key);
      }
    }
  } 

  document.addEventListener('DOMContentLoaded', () => {
    cleanUpFreeItems();
  });

  let timeout;
  document.addEventListener('cart:change', () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cleanUpFreeItems(); 
    }, 200);
  });

  document.addEventListener('cart:updated', () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cleanUpFreeItems();
    }, 200);
  });
})();

/* ==========================================================
SHOW FOOTER AGAIN when the cart becomes empty
theme.js fades the drawer footer out once the cart is empty and only
fades the body back in. The empty cart keeps the discount field in the
footer, so the footer has to come back as well.
========================================================== */

(function() {
  document.addEventListener('cart-drawer:refreshed', (event) => {
    const footer = event.target.shadowRoot && event.target.shadowRoot.querySelector('[part="footer"]');
    if (!footer || footer.style.opacity !== '0') return;

    footer.style.opacity = '';
    footer.style.transform = '';
    footer.animate(
      { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
      { duration: 250, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' }
    );
  });
})();
